<template>
  <div class="legend-item">
    <span ref="itemThumbnail" class="item-thumbnail"></span>
    <span ref="itemLabel" class="item-label">{{ this.$props.label }}</span>
  </div>
</template>
<script>
import { loadModules } from 'esri-loader';

export default {
  id: 'MapLegendItem',
  props: ['symbol', 'label'],
  mounted() {
    loadModules(['esri/symbols/support/symbolUtils'], {
      css: true
    }).then(([symbolUtils]) => {
      symbolUtils.renderPreviewHTML(this.$props.symbol, {
        node: this.$refs.itemThumbnail,
        size: this.$props.symbol.size
      });
    });
  }
};
</script>

<style scoped>
.legend-item {
  align-items: center;
  break-inside: avoid-column;
  padding: 2px;
}
.item-thumbnail {
  margin: 2px;
}
.item-label {
  margin: 2px;
}
</style>
